import { useEffect } from 'react';
import { useAnalytics } from 'src/components/AnalyticsProvider/AnalyticsProvider';
import { useAuth } from 'src/components/AuthProvider/AuthProvider';
import { useSendWelcomeEmailToDiner } from 'src/common/features/DinersManagement/hooks/useSendWelcomeEmailToDiner';

export type UseSendEmployeeWelcomeEmailProps = {
  corpId: string;
  dinerId: string;
  onSent: (dinerId: string) => void;
};

export type UseSendEmployeeWelcomeEmailReturn = {
  sendWelcomeEmail: () => void;
  isLoading: boolean;
};

export const useSendEmployeeWelcomeEmail = ({
  corpId,
  dinerId,
  onSent,
}: UseSendEmployeeWelcomeEmailProps): UseSendEmployeeWelcomeEmailReturn => {
  const {
    enterpriseData: { isInternalAdminUser },
  } = useAuth();
  const { sendTealiumEvent } = useAnalytics();
  const {
    sendWelcomeEmail: sendToDiner,
    isLoading,
    sentWelcomeEmail,
  } = useSendWelcomeEmailToDiner();

  useEffect(() => {
    if (sentWelcomeEmail) {
      onSent(dinerId);
    }
  }, [sentWelcomeEmail, dinerId, onSent]);

  const sendWelcomeEmail = (): void => {
    sendTealiumEvent({
      eventcategory: 'employee section',
      eventaction: 'welcome email icon_cta',
      eventlabel: isInternalAdminUser ? 'internal GH admin' : 'client admin',
    });

    sendToDiner(corpId, dinerId);
  };

  return { sendWelcomeEmail, isLoading };
};
